import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-resource-list-table-container',
	templateUrl: 'resource-list-table-container.component.html',
	styleUrls: ['resource-list-table-container.component.scss']
})
export class ResourceListTableContainerComponent {}
